import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=c9f4aa56&scoped=true&"
import script from "./Positions.vue?vue&type=script&lang=js&"
export * from "./Positions.vue?vue&type=script&lang=js&"
import style0 from "./Positions.vue?vue&type=style&index=0&id=c9f4aa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f4aa56",
  null
  
)

export default component.exports